<script lang="ts" setup>
import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import {useTranslate} from "~/composables/useTranslate"
import { useAppAbility } from "~/shared/casl/useAppAbility";
const {translateKey,t} = useTranslate()
const route = useRoute();
import {version} from "../../../package.json"
const isCollapse = ref(true);
const handleOpen = (key: string, keyPath: string[]) => {
};
const handleClose = (key: string, keyPath: string[]) => {
};

const { can } = useAppAbility();

const items = computed(() => {
  return  [
  {
    title: translateKey("Umumiy ko'rsatkichlar"),
    link: "/dashboard",
    icon: "Dashboard",
    action: 'read',
    subject: 'viewGeneralCharacteristicsOnMenu'
  },
  
  {
    title: translateKey("Ish stoli"),
    link: "/workspace",
    icon: "User",
    action: 'read',
    subject: 'viewWorkstationOnMenu'
  },

  {
    title: translateKey("Ish jarayoni"),
    icon: "Chart",
    action: 'read',
    subject: 'viewProcessOnMenu',
    children: [
      {
        title: translateKey("Loyihalar"),
        link: "/projects",
        action: 'read',
        subject: 'viewProject'
      },
      
      {
        title: translateKey("Loyiha turlari"),
        link: "/project-categories",
        action: 'read',
        subject: 'viewProjectTypeOnMenu'
      },

      {
        title: translateKey("Vazifalar"),
        link: "/tasks",
        action: 'read',
        subject: 'viewTaskOnMenu'
      },
      {
        title: translateKey("Vazifalar taqsimoti"),
        link: "/tasks-distribution",
        action: 'read',
        subject: 'taskAllocationViewOnMenu'
      },
      // {
      //   title: 'Kanban doska',
      //   link: '/kanban'
      // },
    ],
  },
  {
    title:translateKey( "Oylik ish reja"),
    link: "/monthly-plan",
    icon : "Calendar",
    subject: 'viewMonthlyWorkPlanOnMenu',
    action: 'read'
  },
  {
    title: translateKey("Tashkilot tuzilmasi"),
    link: "/structure",
    icon: "StructureIcon",
    action: 'read',
    subject: 'viewSenateStructureOnMenu'
  },

  {
    title: translateKey("Kalendar"),
    link: "/diary",
    icon: "Book",
    action: 'read',
    subject: 'viewDiaryOnMenu'
  },

  {
    title: translateKey("Samaradorlik"),
    link: "/results",
    icon: "Flag",
    action: 'read',
    subject: 'viewEfficiencyOnMenu'
  },
  {
    title: translateKey("Solishtirish"),
    link: can('read', 'viewAllComparison') ? '/compare' : '/compare?type=user',
    icon: "Compare",
    action: 'read',
    subject: 'viewComparisonOnMenu'
  },
  {
    title: translateKey("Ma'lumotnomalar"),
    icon: "References",
    action: 'read',
    subject: 'viewReferencesOnMenu',
    children: [
      {
        title: translateKey("Xodimlar"),
        link: "/staff",
        icon: "Users",
        action: 'read',
        subject: 'viewEmployeeOnMenu'
      },
      {
        title: translateKey("Foiz ko'rsatkichlar"),
        link: "/percentage-indicators",
        icon: "Users",
        action: 'read',
        subject: 'viewPercentageCharacteristicsOnMenu'
      },
      {
        title: translateKey("Bo'limlar"),
        link: "/departments",
        icon: "Notebook",
        action: 'read',
        subject: 'viewDepartmentOnMenu'
      },
      {
        title:t('pages.functional_tasks.title'),
        link: "/functional-tasks",
        icon: "Grid",
        action: 'read',
        subject: 'viewFunctionalTaskOnMenu'
      },
      {
        title: translateKey("Teglar"),
        link: "/tags",
        icon: "Filter",
        action: 'read',
        subject: 'viewTagOnMenu'
      },
      {
        title: translateKey("Lavozimlar"),
        link: "/positions",
        icon: "VideoCall",
        action: 'read',
        subject: 'viewPositionOnMenu'
      },
    ],
  },
  {
    title: translateKey("Video qo'llanma"),
    link: "/video-guide",
    icon: "VideoGuideIcon",
    action: 'read',
    subject: 'usageGuideViewOnMenu'
  },
  {
    title: translateKey("Sozlamalar"),
    icon: "Settings",
    action: 'read',
    subject: 'viewReferencesOnMenu',
    children: [
      {
        title: translateKey("Rollarni boshqarish"),
        link: "/role-management",
        icon: "TwoUser",
        action: 'read',
        subject: 'viewRoleOnMenu'
      },
      // {
      //   title:t(`Kompaniya ma'lumotlari`),
      //   link: "/functional-tasks",
      //   icon: "Grid",
      //   action: 'read',
      //   subject: 'Auth'
      // },
    ],
  },
];
})
</script>

<template>
  <div
    class="tw-relative tw-flex tw-flex-col tw-justify-between tw-bg-[#3361FF] tw-p-[16px] tw-h-[100vh] tw-max-w-[280px] 2xl:tw-max-w-[300px] tw-w-[100%] tw-overflow-hidden"
  >
    <RouterLink
      to="/workspace"
      class="tw-relative tw-z-[1] tw-flex tw-items-center gap-x-[12px] tw-justify-center"
    >
      <!-- <img
        class="tw-w-[230px] tw-object-contain"
        src="@/assets/images/white-logo.png"
        alt="menu-logo"
      /> -->
      <img
        class="tw-w-[64px] tw-object-contain"
        src="@/assets/images/simplex-kpi-logo.svg"
        alt="menu-logo"
      />
      <h3 class="text-[#FFF] text-[28px] font-semibold">Direksiya</h3>
    </RouterLink>
    <!-- <RouterLink
      to="/"
      class="tw-relative tw-z-[1] tw-flex tw-items-center tw-flex-col tw-justify-center"
    >
      <img
        class="tw-w-[236px] tw-object-contain"
        src="/src/assets/images/icons/menu-logo.svg"
        alt="menu-logo"
        width="236"
        height="48"
      />
    </RouterLink> -->
    <el-scrollbar class="tw-relative tw-z-[1] tw-mb-[24px]" height="100%">
      <el-menu
        router
        :default-active="route.path"
        class="el-menu-vertical-demo tw-border-0 pt-[11px] tw-w-[100%] base-sidebar"
        background-color="transparent"
        @open="handleOpen"
        @close="handleClose"
      >
        <template v-for="(item, index) in items" :key="`sidebar-item-${index}`">
          <el-sub-menu
            v-if="item.children?.length && can(item.action, item.subject)"
            :index="item?.link || item?.title"
            class="tw-rounded-lg tw-text-[#FFF]"
          >
            <template #title>
              <div class="tw-text-[#FFF] tw-flex tw-items-center">
                <BaseIcon :name="item.icon" class="tw-mr-2" />
                <span class="">{{ item.title }}</span>
              </div>
            </template>
            <template v-for="(subItem, idx) in item.children">
              <el-menu-item
                v-if="can(subItem.action, subItem.subject)"
                :class="route.path.split('/')[1] === subItem.link.split('/')[1] ? 'active_sidebar-menu' : ''"
                class="tw-text-[#FFF] tw-rounded-[12px] hover:tw-bg-[#4D74FF]"
                :key="`sidebar-submenu-item-${idx}`"
                :index="subItem.link"
                >{{ subItem.title }}</el-menu-item
              >
            </template>
          </el-sub-menu>
          <el-menu-item
            v-else-if="can(item.action, item.subject)"
            :index="item.link"
            :class="route.path.split('/')[1] === item.link.split('/')[1] ? 'active_sidebar-menu' : ''"
            class="hover:tw-bg-[#4D74FF] tw-rounded-lg tw-text-[#FFF]"
          >
            <BaseIcon :name="item.icon" class="tw-mr-2" />
            <template #title>{{ item.title }}</template>
          </el-menu-item>
        </template>
      </el-menu>
    </el-scrollbar>
    <div class="tw-relative tw-z-[1]">
      <div class="tw-relative tw-rounded-[12px] tw-bg-[#406BFF]">
        <div
          class="tw-relative z-[1] tw-flex tw-flex-col tw-gap-y-[12px] tw-p-[16px]"
        >
          <div class="tw-text-left tw-font-medium tw-text-[#fff]">
            {{ translateKey("Tex.yordam") }}
          </div>
          <div class="tw-flex tw-items-center tw-gap-2">
            <BaseIcon name="Call" class="tw-text-[#fff]" />
            <a href="tel:+998940372277" class="tw-text-[#fff] tw-font-semibold"
              >+998 94 037 22 77</a
            >
          </div>
          <div class="tw-flex tw-items-center tw-gap-2">
            <BaseIcon name="Telegram" class="tw-text-[#fff]" />
            <a :href="`https://t.me/rashidov_dev`" target="_blank" class="tw-text-[#fff] tw-font-semibold">{{translateKey("Telegram")}}</a>
          </div>
        </div>

        <div
          class="tw-w-[72px] tw-object-contain tw-absolute z-[0] tw-bottom-[-2px] tw-right-[16px]"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="73"
            height="71"
            viewBox="0 0 73 71"
            fill="none"
          >
            <path
              d="M17.2734 5.71878C26.2826 5.71878 33.897 10.3766 36.3646 17.0963C38.6631 10.3766 46.0294 5.73521 55.4327 5.73521C43.7318 -2.29549 28.2403 -1.5129 17.2734 5.71878Z"
              fill="#4D74FF"
            />
            <path
              d="M56.389 38.9901C61.1073 38.9901 64.9322 35.1187 64.9322 30.3431C64.9322 25.5673 61.1073 21.6959 56.389 21.6959C51.6707 21.6959 47.8457 25.5673 47.8457 30.3431C47.8457 35.1187 51.6707 38.9901 56.389 38.9901Z"
              fill="#4D74FF"
            />
            <path
              d="M16.9275 38.6303C21.4491 38.6303 25.1146 34.9201 25.1146 30.3435C25.1146 25.767 21.4491 22.0568 16.9275 22.0568C12.4058 22.0568 8.74023 25.767 8.74023 30.3435C8.74023 34.9201 12.4058 38.6303 16.9275 38.6303Z"
              fill="#4D74FF"
            />
            <path
              d="M45.3905 68.563C49.478 68.4732 61.1207 62.8956 67.0751 42.2971C63.8001 45.5501 52.8647 46.5482 50.8115 45.7153C44.8321 47.5771 39.7386 53.2755 36.3413 60.087C32.8095 53.4813 27.1127 47.2061 21.9275 45.7153C17.6617 47.6042 9.39711 44.9956 6.81984 43.2854C10.997 59.2068 20.3277 66.6733 27.4383 68.8317C16.8618 67.2124 11.4017 60.742 7.72955 55.5122C4.4841 50.8824 1.13163 43.9184 0.509332 30.6017C0.324997 26.6473 3.25174 37.6712 3.25174 37.6712C6.1631 42.4054 11.101 45.2284 16.4589 45.2284C18.3815 45.2304 20.2869 44.8622 22.0736 44.1435L22.3819 44.0188L22.7055 44.0942C27.8821 45.4468 34.1927 51.4263 36.286 56.5084C38.7621 51.2969 43.0795 46.8835 49.7185 44.0197L50.148 43.7734L50.6349 43.9849C52.5278 44.8084 54.5672 45.2316 56.6276 45.2284C61.9731 45.2284 66.9024 42.4149 69.8148 37.7011C69.8148 37.7011 72.4465 21.7721 72.583 30.5119C72.7434 40.504 69.6105 49.1694 65.3769 55.9422C61.0319 62.8985 52.6766 68.9621 45.3905 68.563Z"
              fill="#4D74FF"
            />
            <path
              d="M29.4644 22.1466C27.6736 17.3312 23.3715 15.71 18.5338 14.7699C9.73476 13.0608 0.492767 13.3304 0.136719 4.24561C3.15879 15.2202 27.3319 2.80603 32.4866 25.9243C32.749 27.1039 29.4644 22.1466 29.4644 22.1466Z"
              fill="#4D74FF"
            />
            <path
              d="M31.2891 22.3416C29.8802 19.7199 27.7992 17.5308 25.2651 16.0049C22.7309 14.479 19.8373 13.6725 16.8888 13.6704C16.7894 13.6704 16.6911 13.6704 16.5937 13.6704C7.69055 13.8297 0.496094 21.2112 0.496094 30.2592C0.496094 30.297 0.496094 30.3337 0.496094 30.3714C0.51174 32.8639 1.08578 35.3203 2.17522 37.5557C2.44936 38.1201 2.75466 38.6685 3.08967 39.1982C5.38807 42.7931 8.97103 45.349 13.0887 46.3314C17.2064 47.3138 21.54 46.6465 25.1826 44.4691C28.8254 42.2916 31.4951 38.7727 32.6332 34.6486C33.7713 30.5243 33.2897 26.1145 31.2891 22.3416ZM16.8926 44.9932C13.0332 44.9912 9.3326 43.4385 6.60373 40.6762C3.875 37.914 2.34115 34.1684 2.33931 30.2622C2.33931 22.1398 8.86848 15.5312 16.8926 15.5312C24.9165 15.5312 31.4466 22.1398 31.4466 30.2622C31.4441 34.1684 29.9099 37.9138 27.181 40.6757C24.4521 43.4378 20.7518 44.9907 16.8926 44.9932Z"
              fill="#4D74FF"
            />
            <path
              d="M43.6095 22.1479C45.4003 17.3325 49.7024 15.7114 54.5401 14.7712C63.3391 13.0622 72.5811 13.3317 72.9372 4.24695C69.9151 15.2216 45.742 2.80351 40.5873 25.9256C40.3238 27.1052 43.6095 22.1479 43.6095 22.1479Z"
              fill="#4D74FF"
            />
            <path
              d="M56.302 13.6704H56.1884C49.4522 13.6704 43.6513 17.8037 41.1342 23.6971C40.1982 25.8946 39.7433 28.2711 39.8007 30.6633C39.8581 33.0555 40.4262 35.4068 41.4663 37.5558C43.2259 41.1823 46.228 44.0378 49.9133 45.5903C52.4038 46.6355 55.1107 47.0426 57.7939 46.7757C60.4771 46.5086 63.0539 45.5757 65.2958 44.0597C67.5376 42.5435 69.3752 40.491 70.6459 38.0841C71.9166 35.6772 72.5809 32.9902 72.58 30.2612C72.58 21.1505 65.2883 13.7322 56.302 13.6704ZM56.1884 44.9922C52.3292 44.9897 48.6288 43.4369 45.9 40.6748C43.1711 37.9128 41.6369 34.1674 41.6344 30.2612C41.6344 22.1388 48.1635 15.5302 56.1884 15.5302C64.2134 15.5302 70.7415 22.1388 70.7415 30.2612C70.7415 30.3241 70.7415 30.3859 70.7415 30.4478C70.7348 30.9761 70.7004 31.5037 70.6385 32.0284C70.2084 35.602 68.5015 38.893 65.8398 41.281C63.1781 43.6689 59.7453 44.9889 56.1884 44.9922Z"
              fill="#4D74FF"
            />
            <path
              d="M30.3357 70.8786C31.0507 70.8786 31.6304 69.8413 31.6304 68.5617C31.6304 67.2821 31.0507 66.2449 30.3357 66.2449C29.6207 66.2449 29.041 67.2821 29.041 68.5617C29.041 69.8413 29.6207 70.8786 30.3357 70.8786Z"
              fill="#4D74FF"
            />
            <path
              d="M33.315 70.8786C34.0302 70.8786 34.6097 69.8413 34.6097 68.5617C34.6097 67.2821 34.0302 66.2449 33.315 66.2449C32.6001 66.2449 32.0205 67.2821 32.0205 68.5617C32.0205 69.8413 32.6001 70.8786 33.315 70.8786Z"
              fill="#4D74FF"
            />
            <path
              d="M39.2977 44.1851C39.0694 45.6923 36.9738 48.6827 36.5098 48.6827C36.0459 48.6827 34.0524 45.6102 33.7983 44.1851C33.363 41.7398 33.9454 39.6876 36.5222 39.6876C39.0304 39.6867 39.6911 41.5505 39.2977 44.1851Z"
              fill="#4D74FF"
            />
            <path
              d="M39.3845 70.8786C40.0995 70.8786 40.6791 69.8413 40.6791 68.5617C40.6791 67.2821 40.0995 66.2449 39.3845 66.2449C38.6695 66.2449 38.0898 67.2821 38.0898 68.5617C38.0898 69.8413 38.6695 70.8786 39.3845 70.8786Z"
              fill="#4D74FF"
            />
            <path
              d="M42.6716 70.8786C43.3866 70.8786 43.9662 69.8413 43.9662 68.5617C43.9662 67.2821 43.3866 66.2449 42.6716 66.2449C41.9566 66.2449 41.377 67.2821 41.377 68.5617C41.377 69.8413 41.9566 70.8786 42.6716 70.8786Z"
              fill="#4D74FF"
            />
          </svg>
        </div>
      </div>
      <div class="tw-flex tw-text-[#fff] tw-justify-between tw-mt-[14px]">
        <div>V {{version}}</div>
        <div>© {{ new Date().getFullYear() }} “Simplex ITC”</div>
      </div>
    </div>

    <div
      class="tw-absolute tw-left-[57px] tw-z-[0] top-2/3 -tw-translate-y-3/4 tw-w-[392px]"
    >
      <!-- <img
        class="tw-w-[392px] tw-object-contain"
        src="/src/assets/images/login/gerb.png"
        alt="gerb"
        width="392"
        height="400"
      /> -->
    </div>
  </div>
</template>

<style scoped>
.base-sidebar {
  --ep-menu-hover-bg-color: #4d74ff !important;
}

.base-sidebar .ep-sub-menu-title {
  --ep-menu-hover-bg-color: #4d74ff !important;
}
:global(.ep-sub-menu__title:hover) {
  border-radius: 12px;
}
:global(.base-sidebar .ep-sub-menu__icon-arrow) {
  color: #fff !important;
}
:global(.active_sidebar-menu) {
  background-color: #4d74ff !important;
}
:global(.base-sidebar .ep-menu-item:not(:first-child)) {
  margin-top: 4px !important;
}
:global(.base-sidebar .ep-sub-menu) {
  margin-top: 4px !important;
}
:global(.base-sidebar .ep-sub-menu > .ep-menu) {
  margin-top: 4px !important;
}
</style>